import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { TextFacade } from '../facades/text.facade';

export function textCleanup<T>(): CanDeactivateFn<T> {
    return () => {
        const textFacade = inject(TextFacade);
        textFacade.clear();

        return true;
    };
}
